import { render, staticRenderFns } from "./OrganizationsMobile.vue?vue&type=template&id=72245a81&scoped=true&lang=pug&"
import script from "./OrganizationsMobile.vue?vue&type=script&lang=js&"
export * from "./OrganizationsMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsMobile.vue?vue&type=style&index=0&id=72245a81&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72245a81",
  null
  
)

export default component.exports